export enum Sort {
  Default = '1',
  LowestPrice = '2',
  HigherPrice = '3',
  Feedback = '4',
}
